export type PlanType = 'year' | 'month' | 'quater' | 'half_year' | 'date';

export type Plan = {
  Planname: string;
  Planid: number;
  plannedTonnage?: number;
  plannedForYear?: number;
  plannedForMonth?: number;
  plannedForQuarter?: string;
  planToDate?: string;
  planFromDate?: string;
  id?: number;
  planId?: number;
  planName?: string;
  planType?: number;
  productWiseDistributePlan?: Array<ProductWiseDistributePlan>;
};

export interface ProductWiseDistributePlan {
  producType: string;
  productCode: string;
  productPercent: number;
  productTonnage: number;
  profilePercent: number;
  profileTonnage: number;
  inputBillet: string;
  isActive: boolean;
}

export interface Product {
  producttype: string;
  productcode: string;
  productdescription: string;
}

export interface PlanProduct {
  producType: string;
  productCode: string;
  productPercent: string | number;
  productTonnage: string | number;
  profilePercent: string | number;
  profileTonnage: string | number;
}

export interface ProfileSelection {
  profileDim: string;
  profileTonnage: number;
  profilePercent: number;
}

export interface ProductDistribution {
  productType: string;
  distributedValue: number;
  calPerCentDistribute: number;
  remainingPercentage: number;
  profileSelections: ProfileSelection[];
}

export const planTypeNumberMap: { value: PlanType; typeId: number; divisor: number }[] = [
  {value: 'month', typeId: 0, divisor: 12},
  {value: 'quater', typeId: 1, divisor: 4},
  {value: 'half_year', typeId: 2, divisor: 2},
  {value: 'year', typeId: 3, divisor: 1},
  {value: 'date', typeId: 4, divisor: 1}
];
